import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, Crown } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ec_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Error al iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-white/15 rounded-sm px-4 py-3 text-white placeholder-white/30 focus:border-[#D4AF37] focus:outline-none transition-colors text-sm";

  return (
    <div className="min-h-screen bg-black grain flex items-center justify-center px-6">
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <Crown size={28} className="text-[#D4AF37] mx-auto mb-4" />
          <div className="font-display font-bold tracking-[0.2em] uppercase text-sm">
            JordyBT<span className="gold-text">_Fitness</span>
          </div>
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/40 mt-1">Panel de administración</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-[#0A0A0A] border border-white/10 rounded-sm p-8 space-y-5">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.15em] text-white/50 mb-2 font-display">Email</label>
            <input data-testid="login-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@jordybtfitness.com" />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.15em] text-white/50 mb-2 font-display">Contraseña</label>
            <input data-testid="login-password" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-red-400 text-xs">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold rounded-sm w-full py-3 text-sm flex items-center justify-center gap-2 disabled:opacity-50">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} /> Acceder</>}
          </button>
        </form>
      </div>
    </div>
  );
}
